// RightPanel.js
import React from 'react';
import { Link } from 'react-router-dom';
import './RightPanel.css';

function RightPanel({ redirects, news, pastorMessage, latestDevotion }) {

    function formatChineseDate(dateString) {
        const date = new Date(dateString);
        const formattedDate = new Intl.DateTimeFormat('zh-Hant', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            weekday: 'long', // Optional: to include the weekday (e.g., 星期四)
            timeZone: 'America/Los_Angeles',
        }).format(date);
    
        return formattedDate;
    }

    return (
        <aside className="right-panel">
        <div className="panel-section">
            <h2>最新崇拜連結</h2>
            {redirects.length > 0 ? (
                redirects.map((redirect, index) => (
                    redirect.redirect_url ? (
                    <a
                        href={redirect.redirect_url}
                        title={redirect.title}
                        target="_blank"
                        rel="noopener noreferrer"
                        key={index}
                    >
                        <button className="button button-m">
                        {redirect.title}
                        </button>
                    </a>
                    ) : (
                    // Handle redirects without a URL (e.g., display a disabled button or skip)
                    <button className="button button-m" key={index} disabled>
                        {redirect.title}（暫無連結）
                    </button>
                    )
                ))
                ) : (
                <p>No redirects available.</p>
            )}
        </div>
        <div className="panel-section">
            <h2>最新消息</h2>
            {news.length > 0 ? (
                <div dangerouslySetInnerHTML={{ __html: news[0].content }} />
            ) : (
                <p>No news available.</p>
            )}
        </div>
        <div className="panel-section">
            <h2>牧者的話</h2>
            <Link to={`/pastor-messages/read/${latestDevotion.submission_id}`} title={latestDevotion.title}>
                <h3>{latestDevotion.title} </h3>
            </Link>
            {latestDevotion.bible} <br />
            {formatChineseDate(latestDevotion.date)}
        </div>
        <div className="panel-section">
            <h2>與牧者面對面</h2>
            <div dangerouslySetInnerHTML={{ __html: pastorMessage.content }} />
        </div>
        </aside>
    );
}

export default RightPanel;



// {
//   "news": [
//     {
//       "summary": "",
//       "content": "親愛的弟兄姊妹，教會目前仍然保持主日崇拜網路直播及實體開放同時進行。",
//       "url": "",
//       "picture1": null,
//       "picture2": null,
//       "remark": "",
//       "title": "主日崇拜及靈修分享"
//     }
//   ],
//   "redirects": [
//     {
//       "title": "中文主日崇拜",
//       "redirect_url": "https://youtube.com/live/12gw69j7l0U?feature=share",
//       "remark": "中文主日崇拜",
//       "url_shortcut": "cn"
//     },
//     {
//       "title": "粵語主日崇拜",
//       "redirect_url": "",
//       "remark": "粵語主日崇拜",
//       "url_shortcut": "yue"
//     },
//     {
//       "title": "English Worship",
//       "redirect_url": "https://youtu.be/CRrNLzK0c18",
//       "remark": "English Worship",
//       "url_shortcut": "en"
//     }
//   ],
//   "latestDevotion": {
//     "name": "沈有方牧師",
//     "title": "神揀選以色列人",
//     "bible": "羅馬書（26）9:1-12",
//     "content": "神揀選以色列人",
//     "remark": ""
//   },
//   "homepageContent": {
//     "title": "首頁",
//     "content": "親愛的朋友, 您好！...",
//     "picture1": null,
//     "picture2": null,
//     "url": "",
//     "category": "Hompage"
//   }
// }